<template>
  <div class="bottom-desc">
    <div class="bottom-desc-title">常见付费问题</div>
    <desc-item
      v-for="(item, index) in cptList"
      :key="index"
      :item="item"
      :index="index + 1"
    />
  </div>
</template>
<script>
import DescItem from './desc-item'
import { list } from './config'
export default {
  props: ['qaData', 'type'],
  name: 'bottom-desc',
  components: {
    DescItem,
  },
  data() {
    return {
      cptList: list,
    }
  },
  watch: {
    qaData(val) {
      if (val) {
        this.cptList = val
      }
    },
  },
}
</script>
<style lang="scss" scoped>
.bottom-desc {
  width: 1200px;
  margin: auto;

  .bottom-desc-title {
    font-size: 24px;
    text-align: center;
    color: #333;
    font-weight: 300;
    padding-bottom: 30px;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/tariff/bottom-desc/index.vue